import config from '../../shared/services/config';
import isFunction from 'lodash/isFunction';
import AuthManager from "../../shared/services/AuthManager";

const loginRedirectUrl = isFunction(config.get('loginRedirectUrl', '/')) ?
  config.get('loginRedirectUrl', '/')(AuthManager.getUser(), true) : config.get('loginRedirectUrl', '/');

class User {

  constructor(params) {
    Object.assign(this, params);
  }

  areCommunicationsVerified() {
    return this.mobileVerified && this.emailVerified;
  }

  getLimitedAccessToken() {
    if(this.limitedToken) {
      return this.limitedToken['access-token'];
    }
  }
  
  getRedirectRoutes() {
    let routes = [];
    if (!this.emailVerified || !this.mobileVerified) {
      return [...routes, '/account/mobile/otp', '/account/email/otp', '/account/setting-up', loginRedirectUrl];
    }
    if(!this.isPasswordSet) {
      return [...routes, '/account/setpassword', '/account/setting-up', loginRedirectUrl]
    }
  }

  showEOTPverificationScreen() {
    return this.emailVerified;
  }

  canLogin() {
    return this.areCommunicationsVerified();
  }

  showETOPLoginScreen() {
    return this.emailVerified;
  }

  showMOTPLoginScreen() {
    return this.mobileVerified;
  }

  showMOTPverificationScreen() {
    return !this.mobileVerified;
  }

  isTellUsMoreRequired() {
    return !this.emailVerified || !this.mobileVerified;
  }

  canLogin() {
    return this.emailVerified || this.mobileVerified;
  }

}

export default User;